import React from "react";
import { ORDER_TABS } from "../../../util/constants";

/**
 * MainDetailsTab Component
 * Displays and manages the Main Details tab content
 * Shows essential order information like Mercury Client ID, Engagement Name, etc.
 */
const MainDetailsTab = ({
  currentTabFields,
  isEditing,
  fieldValues,
  errorFieldArray,
  fieldValidationErrors,
  renderFieldInput,
  hasValidationError,
  getValidationErrorMessage,
}) => {
  if (currentTabFields.length === 0) {
    return (
      <div className="orders-empty-state">
        <p>No fields available for Main Details.</p>
      </div>
    );
  }

  return (
    <div
      className={`details-grid ${!isEditing ? "view-mode" : ""}`}
      key={ORDER_TABS.MAIN_DETAILS}
    >
      {currentTabFields.map((field, index) => (
        <div
          key={`${ORDER_TABS.MAIN_DETAILS}-${field.field}-${index}`}
          className={`details-item ${
            errorFieldArray.includes(field.fieldStateKey) ? "has-error" : ""
          }`}
        >
          <div className="label">{field.labelToShowOnUI}</div>
          <div className="field-container">
            {renderFieldInput(field)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MainDetailsTab;
